import React, { useMemo, useEffect, useState } from 'react'
import { message } from 'antd'
import { answer, getBatchSelectedInfo } from 'component/batch/base'
import { BatchStop, BatchNum, BatchAll } from 'component'
import request from 'meinian-package/src/utils/request'
import Examine from 'component/imageAction/examine'
import { MARK_STATUS } from 'meinian-package/src/component/enum'
import Icon from 'meinian-package/src/component/icon'
import styles from './index.module.less'

export default ({ batchAll, cancelBatch, permissions, needMarkTimes, markTimes, markStatus, $masonry, ...rest }) => {
  const collectIdList = [...getBatchSelectedInfo()].map(_style => (_style[1].collectId))

  const [size, setSize] = useState(0)

  useEffect(() => {
    answer((ids = new Set()) => setSize(ids.size))
  }, [])

  const fetchData = async (_params) => {
    const success = await request.post('/zhikuan/ins/inspiration/batch-mark', { ..._params, collectIdList })
    if (success) {
      $masonry.current?.init()
      message.success('审核成功')
      cancelBatch()
    }
  }

  const fetchDataRemark = async (_params) => {
    const success = await request.post('/zhikuan/ins/inspiration/batch-reset-mark-status', { ..._params, collectIdList })
    if (success) {
      $masonry.current?.init()
      message.success('审核成功')
      cancelBatch()
    }
  }
  const reviewBatch = useMemo(() => {
    if ((permissions === 1 || permissions === 2) && (markStatus === 2 || markStatus === 1)) {
      return true
    }
    return false
  }, [])

  const _onChange = (state, times) => {
    size && fetchData({
      markStatus: state,
      markTimes: times
    })
  }
  const onRemark = (state) => {
    size && fetchDataRemark({
      markStatus: state,
    })
  }
  return <div className={styles['meinian-inspiration-style-batch-check']} {...rest}>
    <BatchAll style={{ margin: '0 24px' }} keyValues={batchAll.map(m => `${m.imageGroupEntityId},${m.inspirationId}`)} infos={batchAll} />
    <BatchNum style={{ marginRight: 40 }} />
    {
        reviewBatch ? <Examine.Remark
          onChange={onRemark}
          hiddenReq={false}
          currentBlog={{ markStatus, markTimes, needMarkTimes }}
        />
          : <>
            <Examine.NotPass
              onChange={_onChange}
              hiddenReq={false}
              currentBlog={{ markStatus, markTimes, needMarkTimes }}
              style={{ marginRight: '8px' }}
              notPassClassName={`meinian-button ghost ${!size && 'disabled'}`}
              notPassIcon={<Icon className="not-pass-icon" type="m-guanbi_miaobian" />}
            />
            <Examine.Pass
              onChange={_onChange}
              hiddenReq={false}
              currentBlog={{ markStatus, markTimes, needMarkTimes }}
              showPass={((MARK_STATUS.PENDING === markStatus || MARK_STATUS.UNSET === markStatus) && markTimes + 1 === needMarkTimes)} // 二审通过应该显示三审通过
              disabled={!size}
              passIcon={<Icon className="pass-icon" type="m-xiaoyan_miaobian" />}
            />
          </>
      }
    <BatchStop onClick={() => cancelBatch()} style={{ marginLeft: '8px' }} />
  </div>
}
